import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_PURPLE_PLUM, PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_FOCUS_SHADOW } from '../../../styles/colors/colors';
var StyledLinkCell = styled('div', {
  shouldForwardProp: function shouldForwardProp(propName) {
    return !(propName === 'isTooltip');
  }
})(function (_ref) {
  var isTooltip = _ref.isTooltip;
  return _objectSpread({
    lineHeight: '48px',
    marginLeft: -16,
    paddingLeft: 16,
    width: 'calc(100% + 16px)',
    cursor: 'pointer',
    'a.EmbersLink': {
      lineHeight: 1
    },
    '&:hover': {
      background: PROMETHEAN_LIGHT_PURPLE,
      i: {
        opacity: 1
      }
    },
    '&:focus-visible': {
      boxShadow: "".concat(PROMETHEAN_FOCUS_SHADOW, " inset"),
      background: PROMETHEAN_LIGHT_PURPLE,
      i: {
        opacity: 1
      }
    },
    i: {
      opacity: 0,
      color: PROMETHEAN_PURPLE_PLUM,
      fontSize: 24,
      marginLeft: 8
    }
  }, isTooltip && {
    lineHeight: '24px',
    '&:hover': {
      background: 'transparent'
    },
    i: {
      opacity: 1,
      lineHeight: '0px'
    }
  });
});
export default StyledLinkCell;